export class ZoneType {
  static get FirstNorth () {
    return 1
  }
  static get SecondNorth () {
    return 2
  }
  static get FirstMiddle () {
    return 3
  }
  static get SecondMiddle () {
    return 4
  }
  static get South () {
    return 5
  }
  static get None () {
    return 6
  }

  static ZoneTypeName (ZoneType) {
    let tmpType = parseInt(ZoneType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '北一'
        break
      case 2:
        name = '北二'
        break
      case 3:
        name = '中一'
        break
      case 4:
        name = '中二'
        break
      case 5:
        name = '南區'
        break
      case 6:
        name = '略'
        break
    }
    return name
  }
}
